import React from 'react';

const CampanaHeader = () => {
  return (
    <header className="campana-header">
      <div className="campana-header__container">
        <div className="campana-header__content">
          <a href="/" className="campana-header__logo">
            <img
              src={require('../../landing-plans/public/logo-alohar.png')}
              alt="Alohar"
              className="campana-header__logo-img"
            />
          </a>
          <a
            href="#planes"
            className="campana-header__cta"
          >
            Ver Planes
          </a>
        </div>
      </div>
    </header>
  );
};

export default CampanaHeader;
